import React, { Fragment } from 'react';
import moment from 'moment';
import { List, ListItem, MenuButton, Icons } from '@silverfort/sf-components';
import { MenuItemDivider } from '../DropdownMenu/MenuItem';

import { NODE_TYPE, NODES_STATES, PUSH_SERVICES_STATUS } from '@silverfort-nodelibs/common/utils/consts';
import ConfirmationMessage from '../Controls/ConfirmationMessage';
import { bigNumberToText, downloadFile, httpGet, httpPost } from '../utils';

import serverIcon from './Images/server.png';
import { Checkbox } from '@material-ui/core';

class PushServiceStatusRow extends React.Component {
    state = {
        isActionSent: false,
        isSendingLogs: false,
        ShowDownloadLogsConfirmation: false,
        isGeneratingLog: this.props.data.isGeneratingLog
    };

    getPushServiceStatus(status, shouldDisplayStandby) {
        let statusText;
        let statusClass;

        switch (status) {
            case PUSH_SERVICES_STATUS.CONNECTED:
                statusText = NODES_STATES.ACTIVE.DISPLAY;
                statusClass = NODES_STATES.ACTIVE.TEXT;
                break;
            case PUSH_SERVICES_STATUS.DISCONNECTED:
                statusText = NODES_STATES.UNREACHABLE.DISPLAY;
                statusClass = NODES_STATES.UNREACHABLE.TEXT;
                break;
            default:
                if (!shouldDisplayStandby) {
                    break;
                }
                statusText = NODES_STATES.STANDBY.DISPLAY;
                statusClass = NODES_STATES.STANDBY.TEXT;
                break;
        }

        return [statusText, statusClass];
    }

    generateLogs = async () => {
        this.setState({ isActionSent: true, isGeneratingLog: true });
        try {
            await httpGet(`/Settings/GeneratePushServerLogs/${this.props.data.id}`);

            setTimeout(() => {
                this.setState({ isActionSent: false });
            }, 2000);
            setTimeout(() => {
                this.setState({ isGeneratingLog: false });
            }, 15000);
        } catch (err) {
            this.setState({ isActionSent: false, isGeneratingLog: false });
            console.error(err);
        }
    };

    validateLastLogsBeforeDownload = () => {
        if (moment().diff(moment(this.props.data.lastLogUpload), 'days') > this.props.logsWarningDaysDiff) {
            this.setState({ ShowDownloadLogsConfirmation: true });
        } else {
            this.downloadLogs();
        }
    };

    downloadLogs = () => {
        this.setState({ ShowDownloadLogsConfirmation: false });
        downloadFile(`/Settings/DownloadPushServerLogs/${this.props.data.id}`);
    };

    sendLogs = () => {
        this.setState({ isSendingLogs: true });
        httpGet(`/Settings/SendLogs/${this.props.data.id}?isPushService=true`)
            .then(() => this.setState({ isSendingLogs: false }))
            .catch((err) => {
                setTimeout(() => this.setState({ isSendingLogs: false }), 2000);
                console.error(err);
            });
    };

    restartPushServer = async () => {
        this.setState({ isActionSent: true });
        try {
            await httpPost(`/Settings/RestartPushServer/${this.props.data.id}`);
            setTimeout(() => {
                this.setState({ isActionSent: false });
            }, 2000);
        } catch (err) {
            this.setState({ isActionSent: false });
            console.error(err);
        }
    };

    ReassignPort = async () => {
        this.setState({ isActionSent: true });
        try {
            await httpGet(`/Settings/ReassignPort/${this.props.data.id}/${NODE_TYPE.ARYA}`);

            setTimeout(() => {
                this.setState({ isActionSent: false });
            }, 2000);
        } catch (err) {
            this.setState({ isActionSent: false });
            console.error(err);
        }
    };

    render() {
        let lastReportDate = 'N/A';
        if (this.props.data.lastStatusUpdate) {
            const updateTime = moment(this.props.data.lastStatusUpdate).local();
            if (updateTime.isValid()) {
                lastReportDate = `${updateTime.format('L')}, ${updateTime.format('LTS')}`;
            }
        }

        let lastLog = 'N/A';
        if (this.props.data.lastLogUpload) {
            const lastLogTime = moment(this.props.data.lastLogUpload).local();
            if (lastLogTime.isValid()) {
                lastLog = `${lastLogTime.format('L')}, ${lastLogTime.format('LTS')}`;
            }
        }

        const [statusText, statusClass] = this.getPushServiceStatus(this.props.data.status, true);
        const [integrationStatusText, integrationStatusClass] = this.getPushServiceStatus(
            this.props.data.integrationStatus
        );

        return (
            <div
                id={`puhsServicesStatus_${this.props.name}`}
                className={'serverRow nodeServerRow messagingServiceRow' + (this.props.isHeader ? ' tableHeader' : '')}>
                <div className="title">
                    <div className="leftSide">
                        {this.props.isHeader && (
                            <Fragment>
                                <Checkbox
                                    disableRipple={true}
                                    checked={this.props.isAllPushServicesSelected}
                                    onChange={() => this.props.checkAllPushServices()}
                                    onClick={(e) => e.stopPropagation()}
                                    color="primary"
                                    style={{
                                        transform: 'scale(0.667)'
                                    }}
                                    className="pl-0"
                                />
                                <div className="tableHeaderTitle notification">Name</div>
                                <div className="tableHeaderTitle notification status">Status</div>
                            </Fragment>
                        )}
                        {!this.props.isHeader && (
                            <Fragment>
                                <Checkbox
                                    disableRipple={true}
                                    checked={this.props.isSelected}
                                    onChange={() => {
                                        this.props.checkPushService();
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                    color="primary"
                                    style={{
                                        transform: 'scale(0.667)'
                                    }}
                                    className="pl-0"
                                />
                                <div className="imgContainer">
                                    <img className="dcIcon" src={serverIcon} alt="" />
                                </div>
                                <div className="aryaHeader" title={`${this.props.name}`}>
                                    <div className="nodeDisplayName">{this.props.name}</div>
                                    {this.props.data.serverUrl && (
                                        <div className="ipAddress" title={this.props.data.serverUrl}>
                                            {this.props.data.serverUrl}{' '}
                                            {this.props.data.isDMZ ? '(External Network)' : ''}
                                        </div>
                                    )}
                                </div>
                                <div className={`wallState ${statusClass}`}>{statusText}</div>
                                {integrationStatusText && (
                                    <div className={`wallState ${integrationStatusClass}`}>
                                        Integration {integrationStatusText}
                                    </div>
                                )}
                            </Fragment>
                        )}
                    </div>
                    <div className="rightSide">
                        {this.props.isHeader && (
                            <Fragment>
                                <div className={'connectedClients notification tableHeaderTitle'}>
                                    Connected Clients
                                </div>
                                <div className={'messagingLastGeneratedLog notification timestamp tableHeaderTitle'}>
                                    Last Generated Log
                                </div>
                                <div className={'lastReport notification timestamp tableHeaderTitle'}>Last Report</div>
                                <div className={'actions notification tableHeaderTitle'}>Actions</div>
                            </Fragment>
                        )}
                        {!this.props.isHeader && (
                            <Fragment>
                                <div className="connectedClients connectedAryas notification">
                                    {bigNumberToText(this.props.data.connectedSocketsCount)}
                                    <span>
                                        Connected Client{this.props.data.connectedSocketsCount !== 1 ? 's' : ''}
                                    </span>
                                </div>
                                <div className="messagingLastGeneratedLog timestamp">
                                    {(this.state.isGeneratingLog || this.props.data.isGeneratingLog) && (
                                        <i className={'fa fa-refresh fa-spin'} aria-hidden="true"></i>
                                    )}
                                    <span>{lastLog}</span>
                                </div>
                                <div className="lastReport timestamp">
                                    <span>{lastReportDate}</span>
                                </div>
                                <div
                                    className="actions"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}>
                                    <MenuButton
                                        className={`left-[-80px] text-left text-white`}
                                        buttonStyle="PrimarySolid"
                                        iconRight={this.state.isActionSent ? undefined : Icons.ChevronDown}
                                        disabled={this.state.isActionSent || !this.props.isEditor}
                                        text={this.state.isActionSent ? 'Sent!' : 'Actions'}
                                        id={'action-dropdown' + this.props.data.guid}
                                        content={
                                            <List>
                                                <ListItem
                                                    title="Generate Logs"
                                                    onClick={this.generateLogs}
                                                    disabled={!this.props.isEditor}
                                                />
                                                <ListItem
                                                    title="Download Logs"
                                                    onClick={this.validateLastLogsBeforeDownload}
                                                    disabled={
                                                        !this.props.data.lastLogUpload ||
                                                        lastLog === 'N/A' ||
                                                        !this.props.isEditor
                                                    }
                                                />
                                                <ListItem
                                                    title={
                                                        this.props.sendingStatus || this.state.isSendingLogs
                                                            ? 'Sending...'
                                                            : 'Send Log'
                                                    }
                                                    onClick={this.sendLogs}
                                                    disabled={
                                                        this.props.sendingStatus ||
                                                        this.state.isSendingLogs ||
                                                        !this.props.isEditor
                                                    }
                                                />
                                                <MenuItemDivider />
                                                <ListItem
                                                    title="Restart Service"
                                                    onClick={this.restartPushServer}
                                                    disabled={
                                                        this.props.data.status === PUSH_SERVICES_STATUS.DISCONNECTED ||
                                                        !this.props.isEditor
                                                    }
                                                />
                                                <ListItem
                                                    title="Reassign Port"
                                                    onClick={this.ReassignPort}
                                                    disabled={!this.props.isEditor}
                                                />
                                            </List>
                                        }
                                    />
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
                {this.state.ShowDownloadLogsConfirmation && (
                    <ConfirmationMessage
                        title={'Download log'}
                        body={`The last log was generated more than ${this.props.logsWarningDaysDiff} day${
                            this.props.logsWarningDaysDiff > 1 ? 's' : ''
                        } ago. Are you sure you want to download?`}
                        approveText={'Download Log'}
                        OnCancel={() => this.setState({ ShowDownloadLogsConfirmation: false })}
                        OnApprove={() => this.downloadLogs()}
                    />
                )}
            </div>
        );
    }
}

export default PushServiceStatusRow;
